var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "flex flex-col p-2 w-full",
      staticStyle: { "min-width": "60vw" }
    },
    [
      _c(
        "el-table",
        {
          staticStyle: { width: "100%" },
          attrs: { data: _vm.list, "row-key": "id", "show-header": false }
        },
        [
          _c("el-table-column", {
            key: "cover",
            attrs: { label: "Cover" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _c(
                      "div",
                      {
                        staticClass:
                          "static inline-block text-center container-action"
                      },
                      [
                        _c("img", {
                          staticStyle: {
                            width: "100px",
                            height: "100px",
                            "object-fit": "cover"
                          },
                          attrs: { src: scope.row.cover }
                        })
                      ]
                    )
                  ]
                }
              }
            ])
          }),
          _vm._v(" "),
          _vm._l(_vm.titles, function(column) {
            return _c("el-table-column", {
              key: column.prop,
              attrs: {
                prop: column.prop,
                label: column.label,
                sortable: "custom"
              }
            })
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "Actions", align: "right", "min-width": "100px" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _c(
                      "div",
                      {
                        staticClass:
                          "static inline-block text-left container-action"
                      },
                      [
                        _c(
                          "VueCustomTooltip",
                          {
                            attrs: {
                              label: !scope.row.added ? "Add" : "Remove",
                              position: "is-left"
                            }
                          },
                          [
                            !scope.row.added
                              ? _c(
                                  "button",
                                  {
                                    staticClass:
                                      "p-2 rounded bg-blue-700 text-blue-100 hover:bg-blue-100 hover:text-blue-700 border duration-200 ease-in-out\n                        border-blue-600 transition focus:outline-none",
                                    on: {
                                      click: function($event) {
                                        return _vm.addPlaylistTo(
                                          scope.row,
                                          true
                                        )
                                      }
                                    }
                                  },
                                  [
                                    _c("font-awesome-icon", {
                                      attrs: { icon: ["fa", "plus"] }
                                    }),
                                    _vm._v(" Add\n            ")
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            scope.row.added
                              ? _c(
                                  "button",
                                  {
                                    staticClass:
                                      "p-2 rounded bg-blue-100 text-blue-700 hover:bg-blue-700 hover:text-blue-100 border duration-200 ease-in-out\n                        border-blue-600 transition focus:outline-none",
                                    on: {
                                      click: function($event) {
                                        return _vm.addPlaylistTo(
                                          scope.row,
                                          false
                                        )
                                      }
                                    }
                                  },
                                  [
                                    _c("font-awesome-icon", {
                                      attrs: { icon: ["fa", "check"] }
                                    }),
                                    _vm._v(" Remove\n            ")
                                  ],
                                  1
                                )
                              : _vm._e()
                          ]
                        )
                      ],
                      1
                    )
                  ]
                }
              }
            ])
          })
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-101c2f10", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-101c2f10","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/AppSetting/SearchPlaylist.vue
// module id = null
// module chunks = 